import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInformation: null,
};

export const userInformationSlice = createSlice({
  name: "userInformation",
  initialState,
  reducers: {
    setUserInformation: (state, action) => {
      state.userInformation = action.payload;
    },
  },
});

export const { setUserInformation } = userInformationSlice.actions;
export default userInformationSlice;